import { decodeToken } from '../../Services/Users.service';

export type TokenUserInfo = {
  email?: string;
  name?: string;
  role?: string;
  userType?: string;
  userId?: string;
};

export const extractUserInfoFromToken = (): TokenUserInfo | null => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return null;
  }

  try {
    const decoded = decodeToken(accessToken) as Record<string, string | undefined>;
    return {
      email: decoded?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
      name: decoded?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
      role: decoded?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
      userType: decoded?.UserType,
      userId: decoded?.UserId,
    };
  } catch {
    return null;
  }
};
